import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';

export {
  PLATFORM_KEY_TOOLTIP,
  UNAVAILABLE_PROVIDER_TOOLTIP,
  providerKeyFromModelId,
  isModelTargetAvailable,
  modelTargetAvailabilityTooltip,
  evaluateModelTargetSubmit,
} from './aiProviderAvailabilityLogic';

/**
 * Admin + own-company probe. Never returns key material.
 * @param {string} companyId
 * @returns {Promise<import('./aiProviderAvailabilityLogic').AiProviderAvailability>}
 */
export async function fetchAiProviderAvailability(companyId) {
  const safe = typeof companyId === 'string' ? companyId.trim() : '';
  if (!safe) {
    throw new Error('companyId is required to probe AI provider availability.');
  }
  const getAiProviderAvailabilityCallable = httpsCallable(
    functions,
    'getAiProviderAvailability',
  );
  const result = await getAiProviderAvailabilityCallable({ companyId: safe });
  return result.data;
}
